import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *	id: number,
 *	projectId: number,
 *	announcementDate: string,
 *	twitterUrl: string,
 *	instagramUrl: string,
 *	linkedInUrl: string,
 *	buildingCommunitiesUrl: string }} CommunicationAnnouncement
 */

/**
 * @typedef {{
 *	id: number,
 *	name: string }} CommunicationStatus
 */
/**
 * @typedef {{
 *	communicationsId: number,
 *	statusId: number,
 *	comment: string }} CommunicationHistoryPayload
 */

const api = new Api("api/communications");

/**
 * @param {number} projectId
 * @returns {Promise<AxiosResponse<CommunicationAnnouncement>>}
 */
export const getAnnouncements = (projectId) =>
  api.get(`announcements/project/${projectId}`);

/**
 * @param {CommunicationAnnouncement} payload
 * @returns {Promise<AxiosResponse<CommunicationAnnouncement>>}
 */
export const createAnnouncement = (payload) =>
  api.post("announcements", payload);

/**
 * @param {number} id
 * @param {CommunicationAnnouncement} payload
 * @returns {Promise<AxiosResponse<CommunicationAnnouncement>>}
 */
export const updateAnnouncement = (id, payload) =>
  api.put(`announcements/${id}`, payload);

/**
 * @returns {Promise<AxiosResponse<CommunicationStatus[]>>}
 */
export const getStatuses = () => api.get("statuses");

/**
 * @param {CommunicationHistoryPayload} payload
 * @returns {Promise<AxiosResponse<any>>}
 */
export const saveHistory = (payload) => api.post("history", payload);
